import { LobbyTable } from 'types/game';

export type TableSeatStatus = 'open' | 'filling' | 'full';

export function tableSeatStatus(table: LobbyTable): TableSeatStatus {
  const seated = Number(table.seated_players) || 0;
  if (seated >= table.max_seats) return 'full';
  if (seated > 0) return 'filling';
  return 'open';
}

export const TABLE_STATUS_LABEL: Record<TableSeatStatus, string> = {
  open: 'Open',
  filling: 'Join now',
  full: 'Full',
};

export const TABLE_STATUS_CLASS: Record<TableSeatStatus, string> = {
  open: 'bg-emerald-500/20 text-emerald-300',
  filling: 'bg-amber-500/20 text-amber-200',
  full: 'bg-red-500/15 text-red-300',
};
